import { useState } from 'react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import SummarizeIcon from '@mui/icons-material/Summarize'
import LogoutIcon from '@mui/icons-material/Logout'
import SearchIcon from '@mui/icons-material/Search'
import AddIcon from '@mui/icons-material/Add'
import MenuIcon from '@mui/icons-material/Menu'
import { AccountCircle, ExitToApp } from '@mui/icons-material'
import Fab from '@mui/material/Fab'
import { styled } from '@mui/material/styles'
import { useNavigate } from 'react-router-dom'
import Viajes from './viajes/Viajes'
import {
  Grid,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import Viajesmostrar from './viajes/Viajesmostrar'
import Resumen from './viajes/Resumen'
import CambiaVehiculo from './config/CambiaVehiculo'

export default function Navbar() {
  const [opendrawer, setOpendrawer] = useState(false)
  const [openviajes, setOpenViajes] = useState(false)
  const [cambiavehiculo, setCambiaVehiculo] = useState(false)

  const eschofer = localStorage.getItem('patente').length > 4
  const [openmostraviajes, setOpenmostraviajes] = useState(eschofer ? true : false)
  const [verresumen, setVerResumen] = useState(false)
  let navigate = useNavigate()

  const StyledFab = styled(Fab)({
    zIndex: 1,
    top: -30,
    left: 0,
    right: 0,
    margin: '0 auto',
  })

  const handleExit = () => {
    localStorage.clear()
    navigate('/')
  }

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position='fixed'>
          <Toolbar variant='small'>
            <IconButton size='large' edge='start' color='inherit' aria-label='menu' sx={{ mr: 2 }}>
              <MenuIcon onClick={() => setOpendrawer(true)} />
            </IconButton>
            <Typography variant='h6' component='div' sx={{ flexGrow: 1 }}>
              T1 - Transporte
            </Typography>
            <IconButton
              size='large'
              //onClick={}
              color='inherit'>
              <AccountCircle />
            </IconButton>
            <IconButton color='inherit' onClick={handleExit} title='Salir'>
              <ExitToApp />
            </IconButton>
          </Toolbar>
        </AppBar>
        <AppBar position='fixed' color='primary' sx={{ top: 'auto', bottom: 0 }}>
          <Toolbar variant='small'>
            {eschofer ? (
              <StyledFab
                color='success'
                aria-label='add'
                onClick={() => [(setOpenViajes(true), setOpenmostraviajes(false))]}>
                <AddIcon />
              </StyledFab>
            ) : null}
            <Box sx={{ flexGrow: 1 }} />
            <Grid container justify='space-between'>
              <Typography variant='body1'>Netizar ©{new Date().getFullYear()}</Typography>
              <div style={{ marginLeft: 'auto' }}>
                {' '}
                {/* lo tira para la derecha*/}
                <Typography variant='body2'>Usuario: {localStorage.getItem('user')}</Typography>
              </div>
            </Grid>
          </Toolbar>
        </AppBar>
        {openviajes ? (
          <Viajes setOpenViajes={setOpenViajes} setOpenViajesMostrar={setOpenmostraviajes} />
        ) : null}
        {openmostraviajes ? <Viajesmostrar /> : null}
        {verresumen ? <Resumen /> : null}
        {cambiavehiculo ? <CambiaVehiculo cerrar={setCambiaVehiculo} /> : null}
      </Box>
      <Drawer anchor='left' open={opendrawer} onClose={() => setOpendrawer(false)}>
        <Box
          p={2}
          width='250px'
          textAlign='left'
          role='presentation'
          onClick={() => setOpendrawer(!opendrawer)}>
          <Typography variant='h6'>Menu</Typography>
          <List>
            {eschofer ? (
              <>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => [
                      setOpenViajes(false),
                      setOpenmostraviajes(true),
                      setVerResumen(false),
                    ]}>
                    <ListItemIcon>
                      <SearchIcon />
                    </ListItemIcon>
                    <ListItemText>Mis viajes</ListItemText>
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => [
                      setOpenViajes(true),
                      setOpenmostraviajes(false),
                      setVerResumen(false),
                    ]}>
                    <ListItemIcon>
                      <AddCircleIcon />
                    </ListItemIcon>
                    <ListItemText>Nuevo viaje</ListItemText>
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => [
                      setOpenViajes(false),
                      setOpenmostraviajes(false),
                      setVerResumen(false),
                      setCambiaVehiculo(true),
                    ]}>
                    <ListItemIcon>
                      <AddCircleIcon />
                    </ListItemIcon>
                    <ListItemText>Cambiar Vehiculo</ListItemText>
                  </ListItemButton>
                </ListItem>
              </>
            ) : null}
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => [
                  setOpenViajes(false),
                  setOpenmostraviajes(false),
                  setVerResumen(true),
                ]}>
                <ListItemIcon>
                  <SummarizeIcon />
                </ListItemIcon>
                <ListItemText>Resumen Periodo</ListItemText>
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton onClick={handleExit}>
                <ListItemIcon>
                  <LogoutIcon />
                </ListItemIcon>
                <ListItemText>Salir</ListItemText>
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </>
  )
}
